import { PayloadAction } from '@reduxjs/toolkit'
import { MapElementWithSectorId } from '@/models/map.ts'
import { CartSliceState } from '@/store/cartSlice/type.ts'
import { getObjectsComparison } from '@/utils/getObjectsComparison'
import { normalizeReservation } from '@/utils/normalizeReservation'
import { normalizeSpot } from '@/utils/normalizeSpot'

export const removeReservationFromCart = (
  state: CartSliceState,
  action: PayloadAction<MapElementWithSectorId | undefined>
) => {
  const element = action.payload
  const cartReservations = state.cartReservations

  if (!cartReservations || !element) {
    return
  }

  const reservationToRemove = cartReservations.find((reservation) => {
    return getObjectsComparison(
      normalizeSpot(element),
      normalizeReservation(reservation)
    )
  })

  if (!reservationToRemove) {
    return
  }

  state.cartReservations = state.cartReservations?.filter((item) => {
    return (
      String(item.spotName + item.spotType) !==
      String(reservationToRemove.spotName + reservationToRemove.spotType)
    )
  })
}
